import { theme } from '@faxi/web-component-library';
import { flex, fontSize, mobile } from '@faxi/web-css-utilities';
import { createGlobalStyle, css } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
 * {
    box-sizing: border-box;
    font-family: "Roboto", sans-serif;
    font-optical-sizing: auto;
    font-style: normal;
    font-variation-settings: "slnt" 0;
  }

  html, body {
    margin: 0;
    text-size-adjust: none;
    scroll-behavior: smooth;
  }

  html, body {
    height: 100%;
  }

  :root {
    --ACCENT_1_1: #03875b !important;
    --PRIMARY_1_1: #00FAA8 !important;
    --SECONDARY_1_1: #2E3246 !important;

    --BACKGROUND_1_1: #2E3246 !important;
    --BACKGROUND_1_2: #3C415A !important;
    --BACKGROUND_2_1: #FFFFFF !important;

    --SHADE_1_1: #2E32460F !important;
    --SHADE_1_2: #E3E8E9 !important;

    --BLUE-01: #013867 !important;

    --RED-EB: #eb0a1e !important;


    --wcl-input-icon-color: #2E3246;
  }

  main {
    ${flex('column', 'stretch', 'stretch')};
  }

  /* override stepper styles */
  .kinto-stepper {
    &__index {
      color: var(--SECONDARY_1_1) !important;
    }

    &__step {
      &__title {
        text-transform: uppercase;
      }

      &--active {
        &::before {
          background: radial-gradient(
            circle,
            var(--PRIMARY_1_1) 0,
            var(--PRIMARY_1_1) 44%,
            var(--ACCENT_1_1) 45%
          ) !important;
        }

        &::after{
          background-color: var(--SHADE_1_2) !important;
        }
      }

      &--completed {
        &::after {
          background-color: rgb(46, 122, 85) !important;
        }
        
        &::before {
          background-color: var(--PRIMARY_1_1) !important;
        }

        svg {
          color: var(--PRIMARY_1_1) !important;
          margin-right: ${theme.sizes.SIZE_4};
        }

        span {
          color: var(--PRIMARY_1_1) !important;
        }

        .kinto-stepper__index {
          color: var(--BACKGROUND_1_1) !important;
        }
      }
    }
  }

  /* override language selector styles */
  .cedolauto-language-selector {
    input {
      color: var(--BACKGROUND_1_1) !important;
    }

    .wcl-select__option {
      color: var(--BACKGROUND_1_2) !important;
      background-color: var(--SHADE_1_2) !important;

      &--selected {
        background-color: var(--BACKGROUND_1_2) !important;
        color: var(--SHADE_1_2) !important;
    }
    }
  }

  .position-relative {
    position: relative;
  }

  .button--outline{
    background: transparent !important;
    opacity: 0.8;

    &:hover{
      opacity: 1;
    }
  }

  html body .wcl-overlay .wcl-modal {
    background-color: white;
    max-width: ${theme.sizes.SIZE_1200};

    &__header {
      margin-bottom: ${theme.sizes.SIZE_24};
    }

    &__content {
      color: black;
      ${fontSize('16px')};

      > *:first-child {
        margin-top: 0;
      }
    }

    &__actions {
      ${flex('row', 'flex-end', 'center')};
      margin-top: ${theme.sizes.SIZE_24};
    }

    &__close-btn {
      display: none;
    }
  }

  html body .wcl-overlay {
    background-color: transparent;
  }

  html body .wcl-overlay .wcl-overlay__content {
    background-color: rgba(0, 0, 0, 0.85);
    padding: 0 ${theme.sizes.SIZE_48};

    ${mobile(css`
      padding: 0 ${theme.sizes.SIZE_16};
    `)}
  }

  .prompt-modal__content {
    color: var(--SECONDARY_1_1);
  }

  .spinner-rotator {
    border-right-color: var(--ACCENT_1_1) !important;
    border-top-color: var(--ACCENT_1_1) !important;
  }

  .google-stars-review {
    ${flex('column', 'center', 'center')};
    gap:${theme.sizes.SIZE_4}
  }

  .google-stars-grade {
    font-size: ${theme.fontSizes.FONT_22};
    font-weight: 500;
  }

  .google-stars-quantity {
    font-size: ${theme.sizes.SIZE_16};
    font-weight: 400;
  }

  .google-stars {
    color: #fbbc04;
    clip-path: polygon(6px 0,4.31px 3.98px,0 4.34px,3.28px 7.18px,2.29px 11.4px,6px 9.16px,9.71px 11.4px,8.72px 7.18px,12px 4.34px,7.69px 3.98px,6px 0,20px 0,18.31px 3.98px,14px 4.34px,17.28px 7.18px,16.29px 11.4px,20px 9.16px,23.71px 11.4px,22.72px 7.18px,26px 4.34px,21.69px 3.98px,20px 0,34px 0,32.31px 3.98px,28px 4.34px,31.28px 7.18px,30.29px 11.4px,34px 9.16px,37.71px 11.4px,36.72px 7.18px,40px 4.34px,35.69px 3.98px,34px 0,48px 0,46.31px 3.98px,42px 4.34px,45.28px 7.18px,44.29px 11.4px,48px 9.16px,51.71px 11.4px,50.72px 7.18px,54px 4.34px,49.69px 3.98px,48px 0,62px 0,60.31px 3.98px,56px 4.34px,59.28px 7.18px,58.29px 11.4px,62px 9.16px,65.71px 11.4px,64.72px 7.18px,68px 4.34px,63.69px 3.98px,62px 0);
    display: inline-block;
    width: 68px;
    height: 11.4px;
    transform: scale(1.5);
    background: linear-gradient(to right, currentcolor 62px, #dadce0 0%);
  }
`;
